import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { DeviceSetting } from '../device-ups-control.model';
import { DeviceUPSControlActions, DeviceUPSControlActionTypes } from '../actions/device-ups-control.actions';

export interface State extends EntityState<any> {
  // additional entities state properties
  isLoaded: boolean;
  isLoading: boolean;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  isLoaded: false,
  isLoading: false,
});

export function reducer(
  state = initialState,
  action: DeviceUPSControlActions
): State {
  switch (action.type) {

    case DeviceUPSControlActionTypes.GetUPSControlStatus: {
      return { ...state, isLoaded: false, isLoading: true };
    }

    case DeviceUPSControlActionTypes.UpsertUPSControlStatus: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    case DeviceUPSControlActionTypes.GetUPSControlStatusFail: {
      return { ...state, isLoaded: true, isLoading: false };
    }

    default: {
      return state;
    }
  }
}

export const getUPSControlState = (state: State) => state;
